import { FC } from 'react'
import classNames from 'classnames'
import { useFormState } from 'react-hook-form'
import { shallow } from 'zustand/shallow'

import { Button } from '@lounge-fe/ui-kit/src/components/Button/index'
import { Icon } from '@lounge-fe/ui-kit'
import { useRecentlyAddedProducts } from '@/features/cart/hooks/useRecentlyAddedProducts'

import { AddToBagButtonProps } from './types'

const animateProps = {
  initial: { opacity: 0 },
  exit: { opacity: 0 },
  animate: { opacity: 1 },
}

const AddToBagButton: FC<AddToBagButtonProps> = ({
  className,
  children,
  productId,
  variantId,
  ...props
}) => {
  const { isSubmitting } = useFormState()
  const recentlyAddedProductIds = useRecentlyAddedProducts(
    (state) => state.recentlyAddedProductIds,
    shallow,
  )

  const addedMatch = variantId && recentlyAddedProductIds.includes(variantId)

  return (
    <Button
      className={classNames('w-full', className)}
      isLoading={isSubmitting}
      {...props}
    >
      {addedMatch ? (
        <span
          className="bg-white flex rounded-circle p-2 w-6 h-6"
          {...animateProps}
        >
          <Icon.Check className="!text-black max-w-full" />
        </span>
      ) : (
        children
      )}
    </Button>
  )
}

export default AddToBagButton
